<template>
  <div class="noteResult">
    <div style="display: flex; justify-content: space-between">
      <h1>
        MY INSTANT MEETINGS
      </h1>

      <button type="button" @click="logout" class="singOut topBtn">SIGN OUT</button>
    </div>
    <div class="noteBoxHolder">
      <button class="createNew fullBtn" @click="openModal">
        <img src="../../assets/fisher-icon-plus.svg" />
        <h2>Create an instant meeting</h2>
      </button>
      <div
        :class="
          meetingDisplay.meetingId === meeting.meetingId
            ? 'noteBox active'
            : 'noteBox'
        "
        v-for="(meeting, index) in getMeetings"
        :key="meeting.meetingId"
        @click="showDetails(meeting)"
      >
        <h2>{{ meeting.title }}</h2>
        <template v-if="meeting.meetingStatus == 3">
          <span
            style="
              font-size: 13px;
              color: rgb(148, 148, 148);
              font-style: italic;
            "
            >Meeting has ended</span
          >
        </template>
        <template
          v-if="meeting.meetingStatus == 0 || meeting.meetingStatus == 1"
        >
          <span
            style="
              font-size: 13px;
              color: rgb(148, 148, 148);
              font-style: italic;
            "
            >Meeting not started</span
          >
        </template>
        <template v-if="meeting.meetingStatus == 2">
          <span
            style="
              font-size: 13px;
              color: rgb(148, 148, 148);
              font-style: italic;
            "
            >Meeting is in progress</span
          >
        </template>
        <span
          style="
            font-size: 13px;
            text-transform: uppercase;
            color: #949494;
            display: block;
          "
        >
          {{ meetingStartDate(meeting.meetingStartTime) }}
          <span
            style="
              font-weight: normal;
              display: inline-block;
              color: #949494;
              margin-left: 10px;
            "
            >{{ meetingStartTime(meeting.meetingStartTime) }} -
            {{ meetingEndTime(meeting.meetingEndTime) }}</span
          >
        </span>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-debugger */
/* eslint-disable no-unused-vars */
import { mapGetters, mapActions, mapMutations } from "vuex";
import MomentTZ from "moment-timezone";
import Moment from "moment";
import store from "@/store";

export default {
  name: "EventList",
  components: {},
  methods: {
    ...mapActions([
      "getAuthToken",
      "fetchMeetings",
      "getMeetingByID",
      "fetchLeaderDetails",
      "decryptData",
      "signOut",
    ]),

    ...mapMutations([
      "setMeetingDisplay",
      "setMeetings",
      // "setShowEventDetails",
      "setShowMeetingDetails",
      "toggleModal",
      "setMeetingModalType",
    ]),
    showDetails(meeting) {
      this.getMeetingByID(meeting.meetingId);
      this.setShowMeetingDetails(true);
      // this.setShowEventDetails(false);
      this.setMeetingDisplay(meeting);
    },
    meetingStartDate(time) {
      console.log(time);
      var zone = Moment.tz.guess();
      return MomentTZ.utc(time).tz(zone).format("MMM Do YYYY");
    },
    meetingStartTime(time) {
      var zone = Moment.tz.guess();
      return MomentTZ.utc(time).tz(zone).format("h:mm a");
    },
    meetingEndTime(time) {
      // return MomentTZ.utc(time).tz(store.state.TimeZone.timeZoneId).format("h:mm a");
      var zone = Moment.tz.guess();
      return MomentTZ.utc(time).tz(zone).format("h:mm a");
    },
    openModal() {
      this.toggleModal();
      this.setMeetingModalType("create");
    },
    logout() {
      this.signOut();
      const token = decodeURIComponent(this.$route.query.data);
      this.$router.push(`/signin?data=${encodeURIComponent(token)}`);
    },
  },
  computed: {
    ...mapGetters(["getMeetings", "leaderDetails", "meetingDisplay"]),
  },
  beforeMount() {
    if (
      this.$store.state.token !== "" &&
      this.$store.state.personId > 0 &&
      this.$store.state.userId > 0 &&
      this.$store.state.roleId > 0
    ) {
      this.fetchLeaderDetails(this.$store.state.personId).then((result) => {
        this.fetchMeetings(this.$store.state.personId);
      });
    } else {
      // let encryptedData = this.$route.query.data;
      // if (encryptedData) {
      //   this.decryptData(encryptedData).then((response) => {
      //     this.getAuthToken().then((result) => {
      //       if (result !== "") {
      //         if (
      //           this.$store.state.personId > 0 &&
      //           this.$store.state.userId > 0 &&
      //           this.$store.state.roleId > 0 &&
      //           this.$store.state.classSessionId > 0 &&
      //           this.$store.state.coreGroupId > 0
      //         ) {
      //           this.fetchLeaderDetails(this.$store.state.personId);
      //           this.fetchMeetings(this.$store.state.personId);
      //         }
      //       }
      //     });
      //   }).catch((error) => {
      //     console.log(error);
      //     this.$confirm({
      //         message: `Ooops your link has expired! Please login to FISHER aplication and try again.`,
      //       });
      //   });
      // } else {
      //   this.$store.commit("setForbiddenAccess");
      // }
    }
  },
};
</script>

<style lang="scss" scoped src="@/styles/style-noteResult.scss">
</style>
